import { useEffect, useRef } from 'react'
import { useQueryParams } from '@fs/zion-router'
import {
  useSharedBrowserDispatchContext,
  useSharedBrowserStateContext,
} from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

/**
 * useInitializeViewModeFromURL - Initialize viewMode to 'group' if cat query param exists.
 * This handles the case where users come from search collection page and land on a natural group.
 * Search reports unsatisfied customers when they click on a DGS in a collection and land in
 * single view, so we default to group view if cat param is present.
 *
 * IMPORTANT: This hook should be called BEFORE useImageBrowserSetup to avoid race conditions
 * where the focused index is set based on the wrong viewMode.
 */
export default function useInitializeViewModeFromURL() {
  const { query } = useQueryParams()
  const { viewMode } = useSharedBrowserStateContext()
  const sharedBrowserDispatch = useSharedBrowserDispatchContext()
  const hasInitialized = useRef(false)

  useEffect(() => {
    // Only run once on mount, and only if cat param exists and we're not already in group mode
    // We dispatch directly to set the viewMode state without triggering the complex
    // state transitions in setViewMode, since this is initial setup
    if (!hasInitialized.current && query?.cat && viewMode !== 'group') {
      sharedBrowserDispatch({ type: 'SET_VIEW_MODE', value: 'group' })
      hasInitialized.current = true
    }
  }, [query?.cat, viewMode, sharedBrowserDispatch])
}
